// features/home/bookFlipBus.ts — one-shot trigger for the book-open page transition
//
// The transition overlay (BookFlipOverlay) has to survive the route change
// it ends in — it stays visible while HomeScreen unmounts and
// BookIndexScreen mounts underneath it — so it's rendered once in
// PageShell, outside HomeScreen's own tree. That means HomeScreen can't
// just call a prop or a local callback to start it; this is a minimal
// pub-sub singleton instead of routing DOM nodes through Zustand (the
// clones this carries are ephemeral, imperative, and read exactly once —
// not reactive app state anything else needs to observe).

export interface BookFlipParams {
  treeId: string;
  /** The clicked book's actual cover button — cloned, not moved, so Home's
   *  own DOM is untouched and the clone can be dropped at any time. */
  sourceEl: HTMLElement;
  /** Every other currently-rendered book cover, for the "gather to a stack
   *  behind the selected one" step. */
  otherEls: HTMLElement[];
}

type Handler = (params: BookFlipParams) => void;

let handler: Handler | null = null;

export function registerBookFlipHandler(fn: Handler | null): void {
  handler = fn;
}

/** Returns true if an overlay was mounted and the transition started. */
export function triggerBookFlip(params: BookFlipParams): boolean {
  if (!handler) return false;
  handler(params);
  return true;
}

export function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
